/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type ImageRegistryProtocolAlreadyExists = {
	error: ImageRegistryProtocolAlreadyExists.error;
};

export namespace ImageRegistryProtocolAlreadyExists {
	export enum error {
		IMAGE_REGISTRY_PROTOCOL_ALREADY_EXISTS = "IMAGE_REGISTRY_PROTOCOL_ALREADY_EXISTS",
	}
}
